import { Link, Navigate } from "react-router-dom";
import { BadgeCheck, Coins, Crown, Globe2, Send, Video } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const FEATURES = [
  [BadgeCheck, "ID Verified", "Every member passes photo ID + selfie review. 18+ only."],
  [Globe2, "Around the World", "Meet generous gentlemen and stunning companions in every city."],
  [Video, "VIP Live Cams", "Private live rooms with chat and token tipping."],
  [Send, "Cash Exchange", "VIPs send money wallet-to-wallet, instantly."],
  [Coins, "Tokens", "100 tokens for $10 · 1,000 tokens for $20."],
  [Crown, "Sell Content", "18+ VIP creators sell exclusive sets. Keep 90%."],
];

const Hero = () => (
  <section className="grain relative min-h-[88vh] overflow-hidden">
    <img src="/images/hero.jpg" alt="" className="absolute inset-0 h-full w-full object-cover object-center opacity-60" />
    <div className="absolute inset-0 bg-gradient-to-r from-[#09090b] via-[#09090b]/85 to-transparent" />
    <div className="relative mx-auto flex min-h-[88vh] max-w-7xl flex-col justify-center px-5 lg:px-8">
      <p className="eyebrow rise mb-6">Est. luxury dating · Worldwide · 18+</p>
      <h1 className="font-display rise max-w-3xl text-5xl font-medium leading-[0.95] sm:text-6xl lg:text-8xl" style={{ animationDelay: "120ms" }}>
        Where elegance meets <span className="italic text-red-600">generosity.</span>
      </h1>
      <p className="rise mt-8 max-w-lg text-base text-zinc-300" style={{ animationDelay: "240ms" }}>
        Diamond Luxury connects ID-verified sugar daddies and sugar babies around the world — with live cams, instant cash exchange and exclusive content.
      </p>
      <div className="rise mt-10 flex flex-wrap gap-4" style={{ animationDelay: "360ms" }}>
        <Link to="/register" data-testid="hero-join-btn" className="btn-red rounded-full px-9 py-4 text-sm font-semibold uppercase tracking-widest">Join Diamond Luxury</Link>
        <Link to="/login" data-testid="hero-login-btn" className="rounded-full border border-white/25 px-9 py-4 text-sm uppercase tracking-widest transition-colors hover:border-white hover:bg-white hover:text-black">Sign in</Link>
      </div>
    </div>
  </section>
);

const Plans = () => (
  <section className="mx-auto max-w-7xl px-5 py-28 lg:px-8">
    <p className="eyebrow mb-4">Membership</p>
    <h2 className="font-display mb-14 max-w-xl text-4xl sm:text-5xl">Two ways to indulge.</h2>
    <div className="grid gap-px bg-white/10 md:grid-cols-2">
      <div className="bg-[#09090b] p-10">
        <p className="eyebrow mb-2">Member</p>
        <p className="font-display text-6xl">$9.99<span className="text-xl text-zinc-500"> / mo</span></p>
        <p className="mt-6 text-zinc-400">Online dating around the world: unlimited messaging, worldwide search, tipping.</p>
      </div>
      <div className="relative bg-[#121215] p-10">
        <div className="absolute right-0 top-0 h-1 w-full bg-red-600" />
        <p className="eyebrow mb-2 !text-amber-300">VIP</p>
        <p className="font-display text-6xl">$19.99<span className="text-xl text-zinc-500"> / mo</span></p>
        <p className="mt-6 text-zinc-400">Everything in Member plus live cams, the cash exchange wallet, and selling 18+ exclusive content.</p>
      </div>
    </div>
  </section>
);

export default function Landing() {
  const { user } = useAuth();
  if (user) return <Navigate to="/discover" replace />;
  return (
    <main data-testid="landing-page">
      <Hero />
      <section className="border-y border-white/5 bg-[#0c0c0f]">
        <div className="mx-auto grid max-w-7xl gap-px bg-white/5 sm:grid-cols-2 lg:grid-cols-3">
          {FEATURES.map(([Icon, t, d]) => (
            <div key={t} className="bg-[#0c0c0f] p-10 transition-colors hover:bg-[#141418]">
              <Icon className="mb-6 h-6 w-6 text-red-600" strokeWidth={1.5} />
              <h3 className="font-display mb-2 text-2xl">{t}</h3>
              <p className="text-sm text-zinc-400">{d}</p>
            </div>
          ))}
        </div>
      </section>
      <Plans />
      <footer className="border-t border-white/5 px-5 py-10 text-center text-xs text-zinc-600">
        © {new Date().getFullYear()} Diamond Luxury · Members must be 18+ · All members are ID verified
      </footer>
    </main>
  );
}
